module.exports = __webpack_public_path__ + "img/b05a114.svg";